export { GTM } from './GTM'
export { GTMEvent } from './declarations/GTMEvent.types'
export * from './declarations'
